import { apiUrlPrefix } from "../../../config";
import Cookies from 'js-cookie';

// --- FETCHING USERS ---
const getAllUsers = async (setName = null) => {
  try {
    // 2. LOG IT HERE to see the list in your console
    const currentUserId = localStorage.getItem('userId');
    //The reason get all users is in Discussions was cause I was not thinking about long term with communities or other features. 
    // Easy fix is to just move the method to MongoDB and to change all places getAllUsers is called and replace Discussion/ with MongoDb/
    const response = await fetch(apiUrlPrefix + `Discussion/getAllUsers?userId=${currentUserId}`, {
      method: "GET",
      credentials: "include",
      headers: { 'Content-Type': 'application/json' },
    });
    if (response.ok) {
      // 1. Capture the data in a variable
      const data = await response.json();



      //Filter the list to remove the current user
      // We compare as strings to avoid type-mismatch bugs
      const findUser = data.find(user => String(user.id) == String(currentUserId));
      if (setName) {
        setName(findUser.name);
      }
      const filteredData = data.filter(user => String(user.id) !== String(currentUserId));
      return await filteredData;
    }
    return [];
  } catch (error) {
    console.error("Fetch failed:", error);
    return [];
  }
};

export default getAllUsers;